module.exports = __webpack_public_path__ + "img/customer-a-032.0fcb8b4f.png";